import { render, staticRenderFns } from "./WhoIsOnLeaveDetail.vue?vue&type=template&id=14bdbbd4"
import script from "./WhoIsOnLeaveDetail.vue?vue&type=script&lang=js"
export * from "./WhoIsOnLeaveDetail.vue?vue&type=script&lang=js"
import style0 from "./WhoIsOnLeaveDetail.vue?vue&type=style&index=0&id=14bdbbd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports